"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _list = _interopRequireDefault(require("./list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Group = function Group(_ref) {
  var children = _ref.children,
      title = _ref.title,
      divided = _ref.divided;
  return _react.default.createElement("li", {
    className: "co-list__item-group"
  }, _react.default.createElement(GroupTitle, null, title), _react.default.createElement(_list.default, {
    divided: divided
  }, children));
};

var GroupTitle = function GroupTitle(_ref2) {
  var children = _ref2.children;
  return _react.default.createElement("span", {
    className: "co-list__item-group-title"
  }, children);
};

Group.propTypes = {
  /** {---} Sequence of: @@<Item>@@ (required, min:1) */
  children: _propTypes.any.isRequired,
  title: _propTypes.string.isRequired,
  divided: _propTypes.bool
};
Group.Title = GroupTitle;
Group.displayName = 'List.Group';
GroupTitle.displayName = 'List.Group.Title';
var _default = Group;
exports.default = _default;
Group.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "List.Group",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of: @@<Item>@@ (required, min:1)"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "divided": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};